import { useState, useEffect } from 'react'

/**
 * Extract table number from URL query parameter
 * Format: ?table=5 or ?table=table-5
 */
function extractTableNumber(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  const params = new URLSearchParams(window.location.search)
  const tableParam = params.get('table')

  if (!tableParam) {
    return undefined
  }

  // Extract numeric part if it's like "table-5"
  const match = tableParam.match(/(\d+)/)
  return match ? match[1] : tableParam
}

// ============================================================================
// Hook: useTableNumber
// ============================================================================

export interface UseTableNumberReturn {
  tableNumber: string | undefined
  hasTableNumber: boolean
}

export function useTableNumber(): UseTableNumberReturn {
  const [tableNumber] = useState<string | undefined>(() => extractTableNumber())

  return {
    tableNumber,
    hasTableNumber: tableNumber !== undefined,
  }
}
